/* ============================================================================
   SYMEDIC — manejo con teclado dentro de las pantallas
   No depende de nada y no cambia ninguna pantalla por dentro: trabaja sobre lo
   que ya se ve (botones por su texto, filas de tablas, campos). Los atajos del
   marco (Ctrl+K, Alt+M, Ctrl+B, Alt+0…9, Ctrl+D) están en
   src/Components/estructura/AtajosGlobales.js.

   Acciones de la pantalla (si hay una ventana abierta, dentro de ella)
     Ctrl+S  o  Ctrl+Enter  Guardar / Grabar (en ventanas también Aceptar, Confirmar…)
     Insert  o  Alt+N       Nuevo / Agregar
     F2                     Editar la fila elegida
     Supr                   Eliminar la fila elegida (la pantalla pide confirmación)
     Alt+L                  Limpiar         Alt+E  Exportar        Alt+F  Filtros
     Ctrl+P                 Imprimir / PDF (si la pantalla no tiene, imprime la página)
     Alt (mantener)         muestra las teclas sobre los botones
   Buscar y campos
     /  F3  Alt+B           ir al buscador
     Enter                  en un buscador: Buscar; en un formulario: pasa al campo
                            siguiente; dentro de una tabla: al campo de abajo
     Shift+Enter            campo anterior
   Tablas y listas
     ↑ ↓  Re Pág  Av Pág  Inicio  Fin   moverse        (desde un buscador ↓ entra)
     Enter abrir · Espacio marcar · Esc volver al buscador
     Ctrl+→ / Ctrl+←        página siguiente / anterior
   ?                        ayuda con todos los atajos
   ============================================================================ */
(function () {
  if (window.__symTeclado) return;
  window.__symTeclado = true;

  var ultimoBuscador = null;
  var MARCO = ".sym-lateral, .sym-superior, .sym-paleta, #sym-ayuda-teclado";

  /* ── utilidades ─────────────────────────────────────────────────────────── */
  function propsReact(el) {
    if (!el) return null;
    for (var k in el) {
      if (k.indexOf("__reactProps$") === 0) return el[k];
    }
    return null;
  }
  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }
  function textoDe(el) {
    var t = el.textContent || el.value || el.getAttribute("title") || el.getAttribute("aria-label") || "";
    return t.replace(/[^\p{L}\p{N}+ ]/gu, " ").replace(/\s+/g, " ").trim().toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  function escribiendo(el) {
    if (!el) return false;
    var t = el.tagName;
    return t === "TEXTAREA" || t === "SELECT" || el.isContentEditable ||
      (t === "INPUT" && !/^(checkbox|radio|button|submit|reset|file|range|color)$/i.test(el.type));
  }
  function enMarco(el) { return !!(el && el.closest && el.closest(MARCO)); }
  function ambito() {
    // con una ventana abierta, todo ocurre dentro de ella; si no, en el contenido de la pantalla
    var modales = document.querySelectorAll(".modal.show");
    if (modales.length) return modales[modales.length - 1];
    return document.querySelector(".sym-contenido") || document;
  }
  function hayModal() { return !!document.querySelector(".modal.show"); }
  function botonPorTexto(regex, raiz) {
    var bs = (raiz || ambito()).querySelectorAll("button, .btn, a.btn, input[type='submit'], input[type='button']");
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      if (visible(b) && !b.disabled && !b.classList.contains("disabled") && !enMarco(b) && regex.test(textoDe(b))) return b;
    }
    return null;
  }
  function botonPorIcono(nombres, raiz) {
    var sel = nombres.map(function (n) { return "[data-sym-ico='" + n + "']"; }).join(",");
    var bs = (raiz || ambito()).querySelectorAll(sel);
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i].closest("button, .btn, a") || bs[i];
      if (visible(b) && !b.disabled) return b;
    }
    return null;
  }
  function aviso(texto) {
    var a = document.getElementById("sym-aviso-tecla");
    if (!a) {
      a = document.createElement("div");
      a.id = "sym-aviso-tecla";
      a.setAttribute("role", "status");
      document.body.appendChild(a);
    }
    a.textContent = texto;
    a.classList.add("visible");
    clearTimeout(a._t);
    a._t = setTimeout(function () { a.classList.remove("visible"); }, 1800);
  }
  function pulsar(b, etiqueta) {
    if (!b) return false;
    var activo = document.activeElement;
    // algunos campos guardan su valor al salir (onBlur): se sale antes de pulsar
    if (activo && activo !== document.body && escribiendo(activo) && activo.blur) activo.blur();
    b.click();
    if (etiqueta) aviso(etiqueta);
    return true;
  }

  /* ── acciones con nombre (las usan los atajos y las teclas sobre los botones) ── */
  var RE = {
    guardar: /^(guardar|grabar|salvar)\b/,
    confirmar: /^(aceptar|confirmar|registrar|actualizar|crear|insertar|agregar|adicionar|aplicar|si\b|ok\b)/,   // nunca Firmar ni Enviar con un atajo
    nuevo: /^(\+|nuev|nueva|agregar|crear|adicionar|anadir)/,
    exportar: /^(exportar|excel|descargar)/,
    filtros: /^(filtro|filtros)/,
    limpiar: /^(limpiar|borrar filtros|nueva busqueda)/,
    imprimir: /^(imprimir|vista previa|ver pdf|generar pdf|pdf\b|stickers?|etiquetas?)/,
    editar: /^(editar|modificar)\b/,
    eliminar: /^(eliminar|borrar|quitar|anular)\b/,
  };
  function botonGuardar() {
    var b = botonPorTexto(RE.guardar) || botonPorIcono(["guardar"]);
    if (b || !hayModal()) return b;
    // en una ventana: el botón de confirmar del pie (Agregar, Aceptar…) o, si no, su botón principal
    var pie = ambito().querySelector(".modal-footer");
    if (pie) {
      b = botonPorTexto(RE.confirmar, pie);
      if (b) return b;
      var prim = pie.querySelectorAll(".btn-primary, .btn-success");
      for (var i = prim.length - 1; i >= 0; i--) {
        if (visible(prim[i]) && !prim[i].disabled && !/firm|envi|anul|elimin|borr|desaprob/.test(textoDe(prim[i]))) return prim[i];
      }
    }
    return botonPorTexto(RE.confirmar);
  }
  function botonNuevo() { return botonPorTexto(RE.nuevo) || botonPorIcono(["nuevo"]); }
  function botonImprimir() { return botonPorTexto(RE.imprimir) || botonPorIcono(["imprimir"]); }

  /* ── marcar filas navegables (las pantallas se dibujan y redibujan solas) ── */
  function esFilaLista(li) {
    if (li.closest(".pagination, nav, .nav, [role='menu'], .dropdown-menu")) return false;
    var p = propsReact(li);
    return !!((p && (p.onDoubleClick || p.onClick)) || li.ondblclick || li.onclick);
  }
  function marcar() {
    var filas = document.querySelectorAll("table > tbody > tr:not([data-sym-fila])");
    for (var i = 0; i < filas.length; i++) {
      if (enMarco(filas[i])) continue;
      filas[i].setAttribute("data-sym-fila", "1");
      if (!filas[i].hasAttribute("tabindex")) filas[i].setAttribute("tabindex", "-1");
    }
    var lis = document.querySelectorAll("ul > li:not([data-sym-fila]):not([data-sym-no])");
    for (var j = 0; j < lis.length; j++) {
      if (!enMarco(lis[j]) && esFilaLista(lis[j])) {
        lis[j].setAttribute("data-sym-fila", "1");
        if (!lis[j].hasAttribute("tabindex")) lis[j].setAttribute("tabindex", "-1");
      } else {
        lis[j].setAttribute("data-sym-no", "1");
      }
    }
    // tablas largas: se desplazan dentro y los títulos quedan fijos
    var conts = document.querySelectorAll(".table-responsive");
    for (var k = 0; k < conts.length; k++) {
      var n = conts[k].querySelectorAll("tbody > tr").length;
      var larga = n > 15 ? "1" : "0";
      if (conts[k].getAttribute("data-sym-larga") !== larga) {
        conts[k].setAttribute("data-sym-larga", larga);
        conts[k].classList.toggle("sym-tabla-larga", larga === "1");
      }
    }
    pista();
    enfocarVentanaNueva();
  }
  // al abrirse una ventana (modal), el cursor queda en su primer campo para escribir de una vez
  var ultimaVentana = null;
  function enfocarVentanaNueva() {
    var modales = document.querySelectorAll(".modal.show");
    var m = modales.length ? modales[modales.length - 1] : null;
    if (m === ultimaVentana) return;
    ultimaVentana = m;
    if (!m) return;
    setTimeout(function () {
      if (!document.contains(m) || (document.activeElement && m.contains(document.activeElement) && document.activeElement !== m &&
          !document.activeElement.classList.contains("modal-dialog"))) return;
      var campos = m.querySelectorAll(SEL_CAMPO);
      for (var i = 0; i < campos.length; i++) {
        if (visible(campos[i]) && campos[i].tabIndex !== -1) { enfocar(campos[i]); return; }
      }
    }, 120);
  }
  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; marcar(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ── moverse entre filas ─────────────────────────────────────────────────── */
  function hermanas(fila) {
    var padre = fila.parentElement;
    var todas = padre ? padre.querySelectorAll(":scope > [data-sym-fila]") : [];
    var out = [];
    for (var i = 0; i < todas.length; i++) if (visible(todas[i])) out.push(todas[i]);
    return out;
  }
  function activar(fila) {
    if (!fila) return;
    var otras = document.querySelectorAll("[data-sym-activa='1']");
    for (var i = 0; i < otras.length; i++) if (otras[i] !== fila) otras[i].removeAttribute("data-sym-activa");
    fila.setAttribute("data-sym-activa", "1");
    fila.focus({ preventScroll: true });
    fila.scrollIntoView({ block: "nearest" });
  }
  function irA(fila, salto) {
    var hs = hermanas(fila);
    var i = hs.indexOf(fila);
    if (i < 0) return;
    var j = Math.max(0, Math.min(hs.length - 1, i + salto));
    activar(hs[j]);
  }
  function abrirFila(fila) {
    var p = propsReact(fila) || {};
    if (p.onDoubleClick || fila.ondblclick) {
      fila.dispatchEvent(new MouseEvent("dblclick", { bubbles: true, cancelable: true, view: window }));
      return;
    }
    if (p.onClick || fila.onclick) { fila.click(); return; }
    // si no: el botón de "abrir/ver/editar/seleccionar" de la fila, o el primero que haya
    var b = botonPorTexto(/^(ver|abrir|editar|seleccionar|elegir|escoger|cargar|detalle)/, fila) ||
            fila.querySelector("button:not([disabled]), a[href], .btn:not(.disabled)");
    if (b) { b.click(); return; }
    var chk = fila.querySelector("input[type='checkbox']:not([disabled])");
    if (chk) chk.click();
  }
  function filaActiva() {
    var el = document.activeElement;
    if (el && el.matches && el.matches("[data-sym-fila]")) return el;
    var a = ambito().querySelector("[data-sym-activa='1']");
    return a && visible(a) ? a : null;
  }
  function primeraFilaDespuesDe(el) {
    var filas = ambito().querySelectorAll("[data-sym-fila]");
    for (var i = 0; i < filas.length; i++) {
      var f = filas[i];
      if (visible(f) && (el.compareDocumentPosition(f) & Node.DOCUMENT_POSITION_FOLLOWING)) return f;
    }
    return null;
  }

  /* ── campos ─────────────────────────────────────────────────────────────── */
  var RE_BUSCAR = /^(buscar|consultar|filtrar|aplicar|traer|cargar)\b/;
  function botonBuscarCerca(input) {
    var nodo = input.parentElement;
    for (var nivel = 0; nodo && nivel < 3; nivel++, nodo = nodo.parentElement) {
      var b = botonPorTexto(RE_BUSCAR, nodo) || botonPorIcono(["buscar"], nodo);
      if (b) return b;
    }
    return null;
  }
  // ¿la pantalla ya maneja las teclas de este campo? (entonces no se interviene)
  function manejaTeclas(el) {
    var n = el;
    for (var i = 0; n && i < 4; i++, n = n.parentElement) {
      var p = propsReact(n);
      if (p && (p.onKeyDown || p.onKeyPress || p.onKeyUp)) return true;
      if (n.onkeydown || n.onkeypress) return true;
    }
    return false;
  }
  var SEL_CAMPO = "input:not([type='hidden']):not([type='checkbox']):not([type='radio']):not([type='file']):not([type='button']):not([type='submit']):not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled]):not([readonly])";
  function campoVecino(el, paso) {
    var todos = Array.prototype.filter.call(ambito().querySelectorAll(SEL_CAMPO), function (c) {
      return visible(c) && !enMarco(c) && c.tabIndex !== -1;
    });
    var i = todos.indexOf(el);
    return i < 0 ? null : todos[i + paso] || null;
  }
  function siguienteCampoEnTabla(input) {
    var celda = input.closest("td, th");
    var fila = input.closest("tr");
    if (!celda || !fila) return null;
    var col = Array.prototype.indexOf.call(fila.children, celda);
    var sig = fila.nextElementSibling;
    while (sig) {
      var c = sig.children[col];
      var campo = c && c.querySelector("input:not([type='checkbox']):not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled])");
      if (campo && visible(campo)) return campo;
      sig = sig.nextElementSibling;
    }
    return null;
  }
  function buscadorPrincipal() {
    var raiz = ambito();
    var campos = raiz.querySelectorAll("input:not([type]), input[type='text'], input[type='search'], input[type='number']");
    var primero = null;
    for (var i = 0; i < campos.length; i++) {
      var c = campos[i];
      if (!visible(c) || c.disabled || c.readOnly || c.closest("table") || enMarco(c)) continue;
      var pista = ((c.placeholder || "") + " " + (c.name || "") + " " + (c.id || "")).toLowerCase();
      if (/busc|filtr|patron|nombre|c[oó]digo|orden|paciente|ident|documento/.test(pista)) return c;
      if (!primero) primero = c;
    }
    return primero;
  }
  function enfocar(c) {
    if (!c) return;
    c.focus();
    if (c.select && c.tagName === "INPUT" && !/^(date|time|datetime-local|month|week|number|email)$/i.test(c.type)) {
      try { c.select(); } catch (e) { /* algunos tipos no permiten seleccionar */ }
    }
  }

  /* ── teclas sobre los botones (mantener Alt) ─────────────────────────────── */
  var marcados = [];
  function mostrarTeclas() {
    ocultarTeclas();
    var pares = [
      [botonGuardar(), "Ctrl S"], [botonNuevo(), "Alt N"], [botonPorTexto(RE.exportar), "Alt E"],
      [botonPorTexto(RE.filtros), "Alt F"], [botonPorTexto(RE.limpiar), "Alt L"], [botonImprimir(), "Ctrl P"],
    ];
    var bus = buscadorPrincipal();
    // el campo no admite la etiqueta encima: se pone en su contenedor solo si lo contiene a él solo
    if (bus && bus.parentElement && bus.parentElement.childElementCount === 1) pares.push([bus.parentElement, "/"]);
    pares.forEach(function (p) {
      if (p[0] && !p[0].hasAttribute("data-sym-tecla")) { p[0].setAttribute("data-sym-tecla", p[1]); marcados.push(p[0]); }
    });
    document.body.classList.add("sym-teclas");
  }
  function ocultarTeclas() {
    marcados.forEach(function (b) { b.removeAttribute("data-sym-tecla"); });
    marcados = [];
    document.body.classList.remove("sym-teclas");
  }
  var tAlt = null;
  window.addEventListener("keydown", function (e) {
    if (e.key === "Alt" && !e.repeat) { clearTimeout(tAlt); tAlt = setTimeout(mostrarTeclas, 350); }
    else if (e.key !== "Alt") { clearTimeout(tAlt); }
  }, true);
  window.addEventListener("keyup", function (e) { if (e.key === "Alt") { clearTimeout(tAlt); ocultarTeclas(); } }, true);
  window.addEventListener("blur", function () { clearTimeout(tAlt); ocultarTeclas(); });

  /* ── ayuda ──────────────────────────────────────────────────────────────── */
  var AYUDA = [
    [
      ["Moverse por el sistema", null],
      ["Ctrl+K", "Ir a cualquier pantalla o acción (escriba parte del nombre)"],
      ["Alt+M", "Buscar en el menú lateral (↑ ↓ → ← Enter)"],
      ["Alt+0", "Inicio"],
      ["Alt+1 … 9", "Pantallas favoritas (la estrella ☆ junto al título)"],
      ["Ctrl+D", "Agregar / quitar la pantalla actual de favoritos"],
      ["Ctrl+B", "Contraer / expandir el menú lateral"],
      ["?", "Mostrar u ocultar esta ayuda"],
      ["Buscar y escribir", null],
      ["/ · F3 · Alt+B", "Ir al buscador de la pantalla"],
      ["Enter", "En un buscador: buscar. En un formulario: pasar al campo siguiente"],
      ["Shift+Enter", "Volver al campo anterior"],
      ["Enter", "Dentro de una tabla: pasar al campo de abajo, como en Excel"],
    ],
    [
      ["Acciones de la pantalla", null],
      ["Ctrl+S · Ctrl+Enter", "Guardar (en una ventana: Guardar, Aceptar o Confirmar)"],
      ["Insert · Alt+N", "Nuevo / Agregar"],
      ["F2", "Editar la fila elegida"],
      ["Supr", "Eliminar la fila elegida (siempre pide confirmación)"],
      ["Alt+L", "Limpiar"],
      ["Alt+E", "Exportar a Excel"],
      ["Alt+F", "Filtros"],
      ["Ctrl+P", "Imprimir / PDF de la pantalla"],
      ["Esc", "Cerrar la ventana abierta"],
      ["Alt", "Mantener presionada: ver la tecla de cada botón"],
      ["Tablas y listas", null],
      ["↑ ↓", "Fila anterior / siguiente (desde un buscador, ↓ entra a la tabla)"],
      ["Re Pág · Av Pág", "Diez filas arriba / abajo"],
      ["Inicio · Fin", "Primera / última fila"],
      ["Enter · Espacio", "Abrir la fila · marcar su casilla"],
      ["Ctrl+→ · Ctrl+←", "Página siguiente / anterior"],
    ],
  ];
  // "Ctrl+S · Ctrl+Enter" → teclas dibujadas; "·" separa alternativas, "+" combina teclas
  function teclas(t) {
    return t.split(" · ").map(function (alt) {
      return alt.split("+").map(function (x) { return '<kbd class="sym">' + x.trim() + "</kbd>"; }).join("");
    }).join(' <span style="color:#98a2b3;margin:0 2px">o</span> ');
  }
  function columna(filas) {
    return "<table>" + filas.map(function (f) {
      return f[1] === null ? '<tr class="grupo"><td colspan="2">' + f[0] + "</td></tr>"
                           : "<tr><td>" + teclas(f[0]) + "</td><td>" + f[1] + "</td></tr>";
    }).join("") + "</table>";
  }
  function ayuda(abrir) {
    var caja = document.getElementById("sym-ayuda-teclado");
    if (!caja) {
      caja = document.createElement("div");
      caja.id = "sym-ayuda-teclado";
      caja.innerHTML = '<div class="caja" role="dialog" aria-modal="true" aria-label="Atajos de teclado">' +
        '<h3>Atajos de teclado <small>Esc o ? para cerrar</small></h3>' +
        '<div class="columnas">' + AYUDA.map(columna).join("") + "</div>" +
        '<div class="pie">Consejo: mantenga presionada la tecla <kbd class="sym">Alt</kbd> en cualquier pantalla para ver qué tecla corresponde a cada botón.</div></div>';
      caja.addEventListener("click", function (e) { if (e.target === caja) ayuda(false); });
      document.body.appendChild(caja);
    }
    var abierta = abrir === undefined ? !caja.classList.contains("abierta") : abrir;
    caja.classList.toggle("abierta", abierta);
    if (abierta) {
      try { localStorage.setItem("sym-ayuda-vista", "1"); } catch (e) { /* sin almacenamiento: da igual */ }
      var p = document.getElementById("sym-pista-teclado");
      if (p) p.remove();
    }
  }
  window.addEventListener("sym:ayuda-teclado", function () { ayuda(); });

  // aviso inicial «? Atajos de teclado» (solo dentro del panel y hasta abrir la ayuda una vez)
  function pista() {
    var p = document.getElementById("sym-pista-teclado");
    var enPanel = !!document.querySelector(".sym-app");
    if (!enPanel) { if (p) p.remove(); return; }
    if (p) return;
    var vista = false;
    try { vista = localStorage.getItem("sym-ayuda-vista") === "1"; } catch (e) { /* nada */ }
    if (vista) return;
    p = document.createElement("div");
    p.id = "sym-pista-teclado";
    p.innerHTML = '<kbd class="sym">?</kbd> Atajos de teclado <button class="cerrar" type="button" aria-label="No mostrar más">×</button>';
    p.addEventListener("click", function (e) {
      if (e.target.classList.contains("cerrar")) {
        try { localStorage.setItem("sym-ayuda-vista", "1"); } catch (er) { /* nada */ }
        p.remove();
        return;
      }
      ayuda(true);
    });
    document.body.appendChild(p);
  }

  /* ── el mouse también deja la fila elegida (para seguir con las flechas) ── */
  document.addEventListener("mousedown", function (e) {
    var fila = e.target.closest && e.target.closest("[data-sym-fila]");
    if (!fila || e.target.closest("input, select, textarea, button, a")) return;
    activar(fila);
  }, true);
  document.addEventListener("focusin", function (e) {
    var t = e.target;
    if (t && t.tagName === "INPUT" && escribiendo(t) && !t.closest("table") && !enMarco(t)) ultimoBuscador = t;
  });

  /* ── teclas ─────────────────────────────────────────────────────────────── */
  document.addEventListener("keydown", function (e) {
    if (e.defaultPrevented || e.isComposing) return;
    var el = document.activeElement;
    var ctrl = e.ctrlKey || e.metaKey;
    var tecla = (e.key || "").toLowerCase();
    var ayudaAbierta = document.querySelector("#sym-ayuda-teclado.abierta");

    if (ayudaAbierta) {
      if (e.key === "Escape" || e.key === "?") { ayuda(false); e.preventDefault(); }
      return;
    }
    if (document.querySelector(".sym-paleta")) return;  // «Ir a…» abierto: maneja sus teclas
    if (enMarco(el)) return;                             // menú lateral y barra superior: tienen las suyas

    // 0) en cualquier parte (también escribiendo): guardar e imprimir
    if (ctrl && !e.altKey && !e.shiftKey && (tecla === "s" || e.key === "Enter")) {
      e.preventDefault();
      if (!pulsar(botonGuardar(), "Guardar")) aviso("Esta pantalla no tiene botón Guardar");
      return;
    }
    if (ctrl && !e.altKey && !e.shiftKey && tecla === "p") {
      var bi = botonImprimir();
      if (bi) { e.preventDefault(); pulsar(bi); }
      return;  // sin botón propio: el navegador imprime la página
    }

    // 1) sobre una fila
    var fila = el && el.matches && el.matches("[data-sym-fila]") ? el : null;
    if (fila && !e.altKey && !ctrl) {
      var mov = { ArrowDown: 1, ArrowUp: -1, PageDown: 10, PageUp: -10, Home: -1e9, End: 1e9 }[e.key];
      if (mov !== undefined) { irA(fila, mov); e.preventDefault(); return; }
      if (e.key === "Enter") { abrirFila(fila); e.preventDefault(); return; }
      if (e.key === " ") {
        var chk = fila.querySelector("input[type='checkbox']:not([disabled])");
        if (chk) chk.click(); else abrirFila(fila);
        e.preventDefault(); return;
      }
      if (e.key === "Escape" && ultimoBuscador && document.contains(ultimoBuscador)) {
        ultimoBuscador.focus(); e.preventDefault(); return;
      }
    }

    // 2) en un campo
    if (el && escribiendo(el) && !e.altKey && !ctrl) {
      if (e.key === "F3") { enfocar(buscadorPrincipal()); e.preventDefault(); return; }
      var enTabla = !!el.closest("table");
      if (e.key === "ArrowDown" && el.tagName === "INPUT" && !enTabla && !/^(number|date|time|datetime-local|month|week)$/i.test(el.type) &&
          !el.getAttribute("list") && !manejaTeclas(el) && el.getAttribute("aria-expanded") !== "true") {
        var f = primeraFilaDespuesDe(el);
        if (f) { ultimoBuscador = el; activar(f); e.preventDefault(); }
        return;
      }
      if (e.key === "Enter" && (el.tagName === "INPUT" || el.tagName === "SELECT")) {
        if (manejaTeclas(el)) return;                          // la pantalla ya hace algo con Enter
        if (e.shiftKey) { var ant = campoVecino(el, -1); if (ant) { enfocar(ant); e.preventDefault(); } return; }
        if (enTabla) {
          var abajo = siguienteCampoEnTabla(el);
          if (abajo) { enfocar(abajo); e.preventDefault(); }
          return;
        }
        if (el.form && el.form.querySelector("[type='submit']")) return;  // el formulario ya lo maneja
        var b = el.tagName === "INPUT" ? botonBuscarCerca(el) : null;
        if (b) { b.click(); e.preventDefault(); return; }
        var sig = campoVecino(el, 1);
        if (sig) { enfocar(sig); e.preventDefault(); }
        return;
      }
      return;  // escribiendo: el resto de teclas son del campo
    }

    // 3) atajos de la pantalla (sin estar escribiendo)
    if (e.key === "?" && !ctrl && !e.altKey) { ayuda(); e.preventDefault(); return; }
    if ((e.key === "/" && !ctrl && !e.altKey) || e.key === "F3" || (e.altKey && !ctrl && tecla === "b")) {
      var bus = buscadorPrincipal();
      if (bus) { ultimoBuscador = bus; enfocar(bus); e.preventDefault(); }
      return;
    }
    if (e.key === "Insert" && !ctrl && !e.altKey) {
      if (pulsar(botonNuevo())) e.preventDefault();
      return;
    }
    if ((e.key === "F2" || e.key === "Delete") && !ctrl && !e.altKey && !e.shiftKey) {
      var fa = filaActiva();
      if (!fa) return;
      var esEditar = e.key === "F2";
      var bf = botonPorTexto(esEditar ? RE.editar : RE.eliminar, fa) || botonPorIcono(esEditar ? ["editar"] : ["eliminar"], fa);
      if (bf) { e.preventDefault(); bf.click(); }
      else if (esEditar) { e.preventDefault(); abrirFila(fa); }
      return;
    }
    if (e.altKey && !ctrl) {
      var mapa = { n: RE.nuevo, e: RE.exportar, f: RE.filtros, l: RE.limpiar };
      var re = mapa[tecla];
      if (re) {
        var boton = tecla === "n" ? botonNuevo() : botonPorTexto(re);
        if (boton) { boton.click(); e.preventDefault(); }
        return;
      }
    }
    if (ctrl && !e.altKey && (e.key === "ArrowRight" || e.key === "ArrowLeft")) {
      var sel = e.key === "ArrowRight" ? ["›", "»siguiente", "siguiente"] : ["‹", "anterior"];
      var links = ambito().querySelectorAll(".pagination .page-item:not(.disabled) .page-link, button");
      for (var i = 0; i < links.length; i++) {
        var t = (links[i].textContent || "").trim().toLowerCase();
        if (sel.indexOf(t) >= 0 && !links[i].disabled && visible(links[i])) { links[i].click(); e.preventDefault(); return; }
      }
    }
  }, false);

  function iniciar() { marcar(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
})();
